import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PractitionerSettings } from 'src/models';
import { api } from 'src/services';

export const useUpdateCurrentPractitionerSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['updateCurrentPractitionerSettings'],
    mutationFn: (
      settings: Partial<
        Omit<
          PractitionerSettings,
          | 'created_at'
          | 'created_by'
          | 'last_modified'
          | 'last_modified_by'
          | 'ambient_version'
          | 'settings'
          | 'note_preferences'
        >
      >
    ) => {
      return api.put('/self/settings', settings).then((res) => res.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['currentPractitionerSettings'],
      });
    },
  });
};
